import { render } from "./SimpleModalContainer.vue?vue&type=template&id=7e7625ca"
import script from "./SimpleModalContainer.vue?vue&type=script&lang=js"
export * from "./SimpleModalContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__